"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _runtime = require("../runtime");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _default = (0, _runtime.IconWrapper)('split-cells', function (props) {
  return _react.default.createElement("svg", {
    width: props.size,
    height: props.size,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("path", {
    d: "M4 14V5C4 4.44772 4.44772 4 5 4H19C19.5523 4 20 4.44772 20 5V43C20 43.5523 19.5523 44 19 44H5C4.44772 44 4 43.5523 4 43V34",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M44 34V43C44 43.5523 43.5523 44 43 44H29C28.4477 44 28 43.5523 28 43V5C28 4.44772 28.4477 4 29 4H43C43.5523 4 44 4.44772 44 5V14",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M28 24L44 24.0132",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M4 24.0132L20 24",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap
  }), _react.default.createElement("path", {
    d: "M39.2275 28.7778L40.8185 27.1868L44.0005 24.0049L40.8185 20.8229L39.2275 19.2319",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }), _react.default.createElement("path", {
    d: "M8.75549 28.7861L7.1645 27.1951L3.98252 24.0132L7.1645 20.8312L8.75549 19.2402",
    stroke: props.outStrokeColor,
    strokeWidth: props.strokeWidth,
    strokeLinecap: props.strokeLinecap,
    strokeLinejoin: props.strokeLinejoin
  }));
});

exports.default = _default;